import { EuiFlexGroup, EuiFlexItem, EuiTitle } from '@elastic/eui';
import { useViewportProvider } from 'providers/viewport-provider/useViewportProvider';
import { useIntl } from 'react-intl';

interface Props {
  children: Array<JSX.Element> | JSX.Element;
  viewportTreshold: number;
}

export const Device = ({
  height = 11,
  width = 11,
  color = 'currentColor',
}: {
  height: number;
  width: number;
  color?: string;
}): JSX.Element => (
  <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 133 54">
    <path
      fill={color}
      d="M100 46h27V6a4 4 0 0 0-4-4H61a4 4 0 0 0-4 4v40h43zm0 2a2 2 0 0 1-2 2H88a2 2 0 0 1-2-2H53a4 4 0 0 0 4 4h70a4 4 0 0 0 4-4h-31zm29-2h4v2a6 6 0 0 1-6 6H57a6 6 0 0 1-6-6v-2h4V6a6 6 0 0 1 6-6h62a6 6 0 0 1 6 6v40zM3 24a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V25a1 1 0 0 0-1-1H3zm0-2h11a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V25a3 3 0 0 1 3-3zm4 28.5a1 1 0 1 1 0-2h3a1 1 0 0 1 0 2H7zM45 2l-6 3v-6l6 3zm-6-.5a.5.5 0 0 1 0 1H26.5a.5.5 0 0 1 0-1H39z"
    />
  </svg>
);
export default Device;

const NotAvailableOnThisDevice = (): JSX.Element => {
  const { formatMessage } = useIntl();
  return (
    <EuiFlexGroup
      justifyContent="spaceAround"
      className="not-available-on-this-device"
      direction="column"
      alignItems="center"
    >
      <EuiFlexItem className="eui-alignMiddle">
        <Device width={300} height={200} color="#006bb4" />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiTitle
          size="m"
          children={
            <h1 style={{ textAlign: 'center', color: '#f55737' }}>
              {formatMessage({ id: 'global.not-available-on-mobile.title' })}
            </h1>
          }
        />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiTitle
          size="s"
          children={
            <h4 style={{ textAlign: 'center' }}>{formatMessage({ id: 'global.not-available-on-mobile.subtitle' })}</h4>
          }
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};

/**
 * @description
 * Accept a "width" treshold and a children
 * conditionally render that children based on the treshold
 * @example
 * ```tsx
 *    <RenderAbove viewportTreshold={1300}>
 * ```
 */
export const RenderAbove = ({ children, viewportTreshold }: Props): JSX.Element => {
  const v = useViewportProvider();
  return <>{v?.vw && viewportTreshold < v.vw ? children : <NotAvailableOnThisDevice />}</>;
};
